import {ActivatedRoute} from '@angular/router';
import {AuthService} from '../services/auth.service';
import {CommonService} from '../services/common.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {CreateLoadingRequestComponent} from '../common/create-loading-request/create-loading-request.component';
import {CreateUnloadingRequestComponent} from '../common/create-unloading-request/create-unloading-request.component';
import {LoadingService} from '../services/loading.service';
import {MatDialog} from '@angular/material';
import OrderDetailsConfig from '../table/configs/purchase_order_details.json';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  templateUrl: './order-details.component.html'
})
export class OrderDetailsComponent implements OnInit {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  public dataSource: MatTableDataSource<any>;
  // tslint:disable-next-line:variable-name
  public order_DetailsConfig: any;
  public purchaseDocument: string;
  public basicDetailsConfig: any;
  public showBasicInfo: boolean;
  private user: any;
  public order: any;

  public displayedColumns: string[] = ['delivery_date', 'material_id', 'material_description', 'quantity_ordered',
    'loaded_quantity', 'quantity_left'];

  constructor(private activatedRoute: ActivatedRoute,
              private authService: AuthService,
              public commonService: CommonService,
              private loadingService: LoadingService,
              private matDialog: MatDialog) {
    this.order = JSON.parse(localStorage.getItem('purchaseOrder'));
    this.purchaseDocument = this.order.purchasing_document;
    this.dataSource = new MatTableDataSource<any>([]);

    this.order.status_id = 4;
    this.showBasicInfo = false;

    this.initUser();
  }

  public ngOnInit(): void {
    this.activatedRoute.params.subscribe(async (params) => {
      const orderDetails = await this.commonService.getListWithParameters('po_details', `${params.id}`) as any[];
      this.dataSource = new MatTableDataSource<any>(orderDetails);
      this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
      this.dataSource.sort = this.sort;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  private async initUser() {
    this.user = await this.authService.getUser();
    this.initBasicInfo();
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      showActions: await this.commonService.showActions(this.user),
      subtitle: [
        {
          title: 'Αριθμός Παραγγελίας',
          value: this.purchaseDocument
        }
      ],
      title: 'Πληροφορίες Παραγγελίας',
      titleURL: false
    };

    this.initializeActions();
  }

  private initializeActions(): void {
    const actions = [];
    const action1 = {
      function: () => {
        this.initializeCreateLoadingRequest(1);
      },
      showAction: this.order.vendor_user_id !== null,
      tooltip: 'Πρέπει να δημιουργήσετε καινούρια κατασκευάστρια',
      title: 'Δημιουργία Εντολής Φόρτωσης',
      icon: 'cloud_upload',
      color: 'green'
    };

    actions.push(action1);

    const action2 = {
      function: () => {
        this.initializeCreateUnloadingOrderDialog(1);
      },
      showAction: this.order.vendor_user_id !== null,
      tooltip: 'Πρέπει να δημιουργήσετε καινούρια κατασκευάστρια',
      title: 'Δημιουργία Εντολής Παραλαβής',
      icon: 'cloud_download',
      color: '#266ccd'
    };

    actions.push(action2);
    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }

    this.showBasicInfo = true;
  }

  private async initializeCreateLoadingRequest(type: number) {
    this.loadingService.show();
    const users = await this.commonService.getListWithParameters('user', 'role_id=2');
    this.loadingService.hide();
    this.matDialog.open(CreateLoadingRequestComponent, {
      // panelClass: 'no-top-padding-dialog',
      data: {
        users,
        order_id: this.order.id,
        type,
        purchaseDocument: this.purchaseDocument
      }
    });
  }

  private async initializeCreateUnloadingOrderDialog(type: number) {
    this.loadingService.show();
    const users = await this.commonService.getListWithParameters('user', 'role_id=6 OR role_id=13 OR role_id=14');
    const details = await this.commonService.getSimpleList(`po_details/${this.order.id}`);
    const roles = await this.commonService.getListWithParameters('role', 'id=6 OR id=13 OR id=14');
    this.loadingService.hide();
    this.matDialog.open(CreateUnloadingRequestComponent, {
      data: {
        orderType: 1,
        roles,
        users,
        details,
        type,
        order_id: this.order.id,
        purchaseDocument: this.purchaseDocument
      }
    });
  }

  public setTableHeight(): number {
    return window.innerHeight - 403;
  }
}
